export default __webpack_public_path__ + "static/media/credit-card.b74592c6.svg";